import React, { useRef } from 'react';
import styled from "@emotion/styled";
import { useHandler } from "@whalecloud/page-builder-core/hooks/useHandler";
import Droppable from "@whalecloud/page-builder-core/components/Dnd/Droppable";
import Element from '@whalecloud/page-builder-core/components/Element';

const ChildContainer = React.memo(
  styled("div")(
    {
      position: "relative",
      width: "100%",
      paddingTop: 16,
      paddingBottom: 16
    }
  )
);

const HeaderCellRender = (props: any) => {
  const ref = useRef<HTMLDivElement>(null);
  const { element, child } = props;

  const handleDrop = useHandler(props, ({ element, index, dropElement }) => (source, direction) => {
    const { id, type } = element;
    dropElement({ source, target: { id, type, position: index }, direction });
  });

  return (
    <Droppable id={child.id} dropRef={ref} type={element.type} directions={['left', 'right']} onDrop={handleDrop}>
      {({ drop }) => {
        return (
          <ChildContainer className="zymzym" ref={drop(ref)} key={child.id}>
            <Element key={child.id} id={child.id} />
          </ChildContainer>
        )
      }}
    </Droppable>
  )
};

export default HeaderCellRender;
